var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import * as React from 'react';

var PlainButton = function PlainButton(_ref) {
    var children = _ref.children,
        _ref$className = _ref.className,
        className = _ref$className === undefined ? '' : _ref$className,
        getDOMRef = _ref.getDOMRef,
        _ref$isDisabled = _ref.isDisabled,
        isDisabled = _ref$isDisabled === undefined ? false : _ref$isDisabled,
        _ref$type = _ref.type,
        type = _ref$type === undefined ? 'submit' : _ref$type,
        rest = _objectWithoutProperties(_ref, ['children', 'className', 'getDOMRef', 'isDisabled', 'type']);

    var buttonProps = {};
    if (isDisabled) {
        buttonProps['aria-disabled'] = true;
        buttonProps.onClick = function (event) {
            event.preventDefault();
            event.stopPropagation();
        };
    }

    return React.createElement(
        'button',
        _extends({
            className: 'btn-plain ' + className,
            type: type,
            ref: getDOMRef
        }, rest, buttonProps),
        children
    );
};

PlainButton.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    getDOMRef: PropTypes.func,

    /** Whether this button should be functionally disabled but still react on hover/focus for tooltips */
    isDisabled: PropTypes.bool,
    type: PropTypes.oneOf(['button', 'reset', 'submit'])
};
export default PlainButton;
import PropTypes from 'prop-types';